import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SeoProvider } from '../../providers/seo.provider';
import { SpinnerProvider } from '../../components/spinner/spinner.provider';

@Component({
  selector: 'component-epk',
  templateUrl: './epk.page.html',
  styleUrls: ['./epk.page.scss']
})

export class EPKPage {

  page: number = 1;
  totalPages: number;
  isLoaded: boolean = false;

    constructor(private router: Router, private seoProvider: SeoProvider, private spinner: SpinnerProvider) {
      seoProvider.setTitle("Angelcrypt | EPK");
    }

    afterLoadComplete(pdfData: any) {
      this.totalPages = pdfData.numPages;
      this.isLoaded = true;
    }

    nextPage() {
      this.page++;
    }

    prevPage() {
      this.page--;
    }
  }



